import { Button, Divider, Form, Input, message, Modal, Typography } from "antd";
import classes from "./integrations.module.scss";
import { RiseOutlined, SwapOutlined } from "@ant-design/icons";
import logoDark from "../../assets/images/sord_logo_transparent.png";
import { useEffect, useState } from "react";

const IntegrationModal = ({
  isOpen,
  onClose,
  selectedApp,
  handleConnectApp,
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [integrationForm] = Form.useForm();

  const handleConnect = (formData) => {
    setIsLoading(true);
    setTimeout(() => {
      handleConnectApp({
        ...selectedApp,
        status: formData ? "Connected" : "Disconnected",
        statusColor: formData ? "#4caf50" : "#b7b7b7",
        integratedKeys: formData,
      });
      setIsLoading(false);
      onClose();
      integrationForm.resetFields();
      message.success(
        `You have successfully ${formData ? "connected" : "disconnected"} ${
          selectedApp.title
        } to Radar+`
      );
    }, 2000);
  };

  const onFinish = (values) => {
    handleConnect(values);
  };

  return (
    <Modal centered open={isOpen} onCancel={onClose} footer={null}>
      <div className={classes.modalContainer}>
        <div className={classes.integratedAppsCnt}>
          <img src={selectedApp.image} height={50} />
          <SwapOutlined style={{ fontSize: "25px", color: "#989898" }} />
          <img src={logoDark} height={50} className={classes.logoDark} />
        </div>
        <span className={classes.title}>
          {selectedApp.integratedKeys
            ? ` ${selectedApp.title} Connected to Radar+`
            : `Connecting ${selectedApp.title} to Radar+`}
        </span>
        <span className={classes.subTitle} style={{ textAlign: "center" }}>
          {selectedApp.description}
        </span>
        <div className={classes.formContainer}>
          {!selectedApp.integratedKeys && (
            <Form
              form={integrationForm}
              onFinish={onFinish}
              layout="vertical"
              requiredMark="optional"
            >
              <Form.Item
                name="api_key"
                rules={[
                  {
                    required: true,
                    message: "Please input your API Key!",
                  },
                ]}
              >
                <div className={classes.inputContainer}>
                  <span>API Key</span>
                  <Input placeholder="Enter your QuickBooks API Key" />
                </div>
              </Form.Item>
              <Form.Item
                name="submitter_id"
                rules={[
                  {
                    required: true,
                    message: "Please input your Submitter ID!",
                  },
                ]}
              >
                <div className={classes.inputContainer}>
                  <span>Submitter ID</span>
                  <Input placeholder="Enter your submitter ID" />
                </div>
              </Form.Item>
              <Button
                type="primary"
                block
                loading={isLoading}
                htmlType="submit"
              >
                {isLoading ? "Connecting..." : "Connect"}
              </Button>
            </Form>
          )}
          {selectedApp.integratedKeys && (
            <Button
              type="primary"
              block
              onClick={() => handleConnect(null)}
              loading={isLoading}
            >
              {isLoading
                ? `Disconnecting ${selectedApp.title}...`
                : `Disconnect ${selectedApp.title}`}
            </Button>
          )}
        </div>
        <Divider />
        <span className={classes.subTitle}>
          By clicking on Allow access, you authorize Radar+ to use your
          information in accordance with its{" "}
          <Typography.Link>Privacy Policy.</Typography.Link> You can stop it at
          any time on the integrations page of your account.
        </span>
        <span
          className={classes.subTitle}
          style={{ display: "inline-block", marginTop: "15px" }}
        >
          {" "}
          <Typography.Link>
            Read Documentation <RiseOutlined />
          </Typography.Link>{" "}
        </span>
      </div>
    </Modal>
  );
};
export default IntegrationModal;
